/** Icons of the controls: theme, menus, zoom, search, framing. Same set as the rest (outline,
 *  grid 24, stroke 1.7); `Icon` merges every file. */
export const CONTROL_PATHS = {
  sun: (
    <>
      <circle cx="12" cy="12" r="4.2" />
      <path d="M12 2.6v2.2M12 19.2v2.2M2.6 12h2.2M19.2 12h2.2M5.4 5.4l1.6 1.6M17 17l1.6 1.6M18.6 5.4 17 7M7 17l-1.6 1.6" />
    </>
  ),
  moon: <path d="M20 14.6A8.4 8.4 0 0 1 9.4 4a8.4 8.4 0 1 0 10.6 10.6Z" />,
  chevron: <path d="M6 9.5 12 15.5 18 9.5" />,
  close: <path d="M6 6l12 12M18 6 6 18" />,
  plus: <path d="M12 5v14M5 12h14" />,
  minus: <path d="M5 12h14" />,
  search: (
    <>
      <circle cx="10.6" cy="10.6" r="6.8" />
      <path d="M15.6 15.6 20.8 20.8" />
    </>
  ),
  target: (
    <>
      <circle cx="12" cy="12" r="5" />
      <path d="M12 2.6v3.2M12 18.2v3.2M2.6 12h3.2M18.2 12h3.2" />
    </>
  ),
  // Measure on the map (ADR 0020): a scale bar with its ticks.
  ruler: <path d="M3.4 12h17.2M3.4 8.6v6.8M20.6 8.6v6.8M8 10.2v3.6M12 9.8v4.4M16 10.2v3.6" />,
  // Print the map (ADR 0020): a printer with its sheet.
  print: (
    <>
      <path d="M6.6 9V3.6h10.8V9" />
      <rect x="3.4" y="9" width="17.2" height="7.6" rx="1.2" />
      <path d="M6.6 14h10.8v6.4H6.6z" />
    </>
  ),
} as const;
